// @mui
import Box from '@mui/material/Box';
// routes
import { usePathname } from 'src/routes/hook';
// components
import WhatsAppButton from 'src/components/whatsapp-button';
// import ChatWidget from 'src/components/chat-widget';
//
import Footer from './footer';
import Header from './header';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function MainLayout({ children }: Props) {
  const pathname = usePathname();

  const isHome = pathname === '/';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      <Header />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ...(!isHome && {
            pt: { xs: 8, md: 10 },
          }),
        }}
      >
        {children}
      </Box>

      <Footer />

      {/* Floating action buttons */}
      {/* <ChatWidget /> */}
      <WhatsAppButton />
    </Box>
  );
}
